/* eslint-disable array-element-newline */
/* eslint-disable max-len, react/jsx-no-bind, no-warning-comments */
import {CardCvvElement, CardMonthElement, CardNumberElement, CardYearElement, useRecurly} from "@recurly/react-recurly";
import React, {useRef, useState} from "react";
import CartAPI from "../../shared/modules/CartAPI";
import InputField from "../../shared/components/InputField";
import LoadingSpinner from "../../bundles/BuyItNow/components/LoadingSpinner";
import PropTypes from "prop-types";

const BillingInfoForm = ({
  customerInfo,
  setDisplayErrors,
  setError,
  setIsBillingInfoEdit
}) => {
  const getFirstName = fullName => fullName.split(" ")[0];
  const getLastName = fullName => fullName.split(" ")[-1];

  const [name, setName] = useState(customerInfo.name);
  const [firstName, setFirstName] = useState(getFirstName(customerInfo));
  const [lastName, setLastName] = useState(getLastName(customerInfo));
  const [isLoading, setIsLoading] = useState(false);

  const formRef = useRef();
  const recurly = useRecurly();

  const handleNameChange = (event) => {
    setName(event.target.value);
    setFirstName(event.target.value);
    setLastName(event.target.value);
  };

  const submitBillingInfo = () => {
    recurly.token(formRef.current, (err, token) => {
      if (err) {
        setError(err);
        setDisplayErrors(true);
        setIsLoading(false);
      } else {
        const billingInfo = {"recurlyToken": token.id};

        CartAPI.updateBillingInfo(billingInfo).then((response) => {
          if (response.error) {
            setError({"message": response.error});
            setDisplayErrors(true);
          } else {
            setIsBillingInfoEdit(false);
          }
        });
        setIsLoading(false);
      }
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsLoading(true);
    submitBillingInfo();
  };

  return (
    <form
      className="billing-info-form"
      ref={formRef}
    >
      <InputField
        className="name-field"
        id="billing-name-field"
        label="Name on card"
        onChange={handleNameChange}
        value={name}
      />
      <div className="card-number-field">
        <label className="input-field-label">
          Card number
        </label>
        <CardNumberElement
          className="billing-field"
          id="number"
        />
      </div>
      <div className="month-field">
        <label className="input-field-label">
          Month
        </label>
        <CardMonthElement
          className="billing-field"
          id="month"
        />
      </div>
      <div className="year-field">
        <label className="input-field-label">
          Year
        </label>
        <CardYearElement
          className="billing-field"
          id="year"
        />
      </div>
      <div className="security-code-field">
        <label className="input-field-label">
          Security Code
        </label>
        <CardCvvElement
          className="billing-field"
        />
      </div>
      <div className="zip-field">
        <label className="input-field-label">
          Zip
        </label>
        <input
          className="input-field-input"
          data-recurly="postal_code"
          id="postal_code"
        />
      </div>
      <div className="action">
        <input
          data-recurly="first_name"
          hidden
          value={firstName}
        />
        <input
          data-recurly="last_name"
          hidden
          value={lastName}
        />
        <input
          data-recurly="country"
          disabled
          hidden
          value="US"
        />

        <button
          className="btn btn-primary cart-save-button"
          disabled={isLoading}
          onClick={handleSubmit}
          type="submit"
        >
          {isLoading ? <LoadingSpinner /> : "Save"}
        </button>
      </div>
    </form>
  );
};

BillingInfoForm.propTypes = {
  "customerInfo": PropTypes.string.isRequired,
  "setDisplayErrors": PropTypes.func.isRequired,
  "setError": PropTypes.func.isRequired,
  "setIsBillingInfoEdit": PropTypes.func.isRequired
};

export default BillingInfoForm;
